import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import { Collapse, Select, Typography } from '@material-ui/core'
import { FORM_LABELS, FORM_PROPS } from '../constants'
import { FormInput } from './index'

const useStyles = makeStyles(() => ({
  intro: {
    padding: '36px 24px 0 24px',
  },
  form: {
    padding: ({ padding }) => padding || '36px 24px 64px 24px',
  },
  textInput: {},
  selectInput: { marginTop: 10 },
  radio: {
    marginTop: 24,
  },
  button: {
    marginTop: 24,
  },
}))

const FormBase = ({
  formData,
  formErrors,
  formRefs,
  onChange,
  onSubmit,
  buttonText,
  exclude,
  padding,
  preDisclaimer,
}) => {
  const [unionMember, setUnionMember] = useState(null)
  const classes = useStyles({ padding })
  const fData = { formData, formErrors, formRefs, onChange }

  const getSelectInput = ({ field, required }) => (
    <>
      <FormLabel>{FORM_PROPS[field].label}</FormLabel>
      <Select
        inputRef={formRefs[field]}
        error={formErrors[field]}
        placeholder={FORM_LABELS[field]}
        variant="outlined"
        fullWidth
        native
        required={required}
        name={field}
        className={classes.selectInput}
        value={formData[field]}
        onChange={(e) => onChange(field, e)}
      >
        <option aria-label="None" value="" />
        {FORM_PROPS[field].options.map((option) => (
          <option key={option} value={_.snakeCase(option)}>
            {option}
          </option>
        ))}
      </Select>
    </>
  )

  return (
    <Grid container direction="row" spacing={2} component="form" className={classes.form}>
      <Grid item xs={12} md={6}>
        <FormInput {...fData} fieldName="first_name" required />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInput {...fData} fieldName="last_name" required />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInput {...fData} fieldName="email" required />
      </Grid>
      {!exclude?.phoneNumber && (
        <Grid item xs={12} md={6}>
          <FormInput {...fData} fieldName="phone_number" />
        </Grid>
      )}
      {!exclude?.address && (
        <Grid item xs={12} md={6}>
          <FormInput {...fData} fieldName="address" />
        </Grid>
      )}
      <Grid item xs={12} md={6}>
        <FormInput {...fData} fieldName="postcode" required />
      </Grid>
      {preDisclaimer && (
        <Grid item xs={12}>
          <Typography variant="body2">{preDisclaimer}</Typography>
        </Grid>
      )}
      {!exclude?.union && (
        <Grid item xs={12}>
          <FormControl component="fieldset" className={classes.radio}>
            <FormLabel component="legend">Are you a union member? *</FormLabel>
            <RadioGroup
              aria-label="union"
              name="union"
              value={unionMember}
              row
              onChange={(evt) => setUnionMember(evt.target.value)}
            >
              <FormControlLabel value="true" control={<Radio required />} label="Yes" />
              <FormControlLabel value="false" control={<Radio required />} label="No" />
            </RadioGroup>
          </FormControl>
        </Grid>
      )}
      {!exclude?.union && (
        <Grid item xs={12}>
          <Collapse in={unionMember === 'true'}>
            {getSelectInput({ field: 'union_member' })}
          </Collapse>
        </Grid>
      )}
      {!exclude?.schoolRole && (
        <Grid item xs={12}>
          {getSelectInput({ field: 'school_role' })}
        </Grid>
      )}
      <Grid item xs={12}>
        <FormControl component="fieldset" className={classes.radio}>
          <FormLabel component="legend">
            If you are not already subscribed, would you like to receive email updates
            from No Child Left Behind and National Education Union? *
          </FormLabel>
          <RadioGroup
            aria-label="opt in"
            name="opt_in"
            value={formData['opt_in']?.toString()}
            error={formErrors['opt_in']}
            onChange={(e) =>
              onChange('opt_in', { target: { value: e.target.value === 'true' } })
            }
          >
            <FormControlLabel
              value="true"
              control={<Radio required />}
              label="Yes, opt in to email updates"
            />
            <FormControlLabel
              value="false"
              control={<Radio required />}
              label="No, do not opt in"
            />
          </RadioGroup>
        </FormControl>
        <Typography variant="body2">
          Note: If you subscribed earlier, this will not unsubscribe you. You can
          unsubscribe using the link provided in emails you receive. You can always take
          action without opting in.
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          onClick={onSubmit}
          className={classes.button}
        >
          {buttonText}
        </Button>
      </Grid>
    </Grid>
  )
}

export default FormBase
